import { render } from "./index.vue?vue&type=template&id=8d10c014&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8d10c014&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境/M平台/前端/servicepartner.matchupexpo.com - 外呼合作方端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d10c014"]])

export default __exports__